export const lacQueryKeys = {
  all: ['lac'] as const,

  usersByTenant: () => [...lacQueryKeys.all, 'usersByTenant'] as const,

  user: (tenantName: string, userRef: string) =>
    [...lacQueryKeys.all, 'user', tenantName, userRef] as const,

  userRoles: (tenantName: string, userRef: string) =>
    [...lacQueryKeys.all, 'userRoles', tenantName, userRef] as const,

  tenants: () => [...lacQueryKeys.all, 'tenants'] as const,

  tenant: (tenantName: string) =>
    [...lacQueryKeys.all, 'tenant', tenantName] as const,

  tenantOverviews: (range?: { fromDate: string; toDate: string } | null) =>
    [...lacQueryKeys.all, 'tenantOverviews', range ?? null] as const,

  crawlJobs: (filters?: {
    startUrl?: string | null;
    tenantName?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    status?: readonly string[] | null;
    offset?: number | null;
    limit?: number | null;
  }) =>
    [
      ...lacQueryKeys.all,
      'crawlJobs',
      filters?.tenantName ?? null,
      filters?.startUrl ?? null,
      filters?.fromDate ?? null,
      filters?.toDate ?? null,
      filters?.status ?? null,
      filters?.offset ?? null,
      filters?.limit ?? null,
    ] as const,

  tenantOverview: (
    tenantName: string,
    range?: { fromDate: string; toDate: string } | null,
  ) =>
    [...lacQueryKeys.all, 'tenantOverview', tenantName, range ?? null] as const,

  chatbotAnalytics: (
    tenantName: string,
    range?: { fromDate: string; toDate: string } | null,
    groupByKnowledgeBase?: boolean,
  ) =>
    [
      ...lacQueryKeys.all,
      'chatbotAnalytics',
      tenantName,
      range ?? null,
      groupByKnowledgeBase ?? false,
    ] as const,

  platformChatAnalytics: (
    tenantName: string,
    range?: { fromDate: string; toDate: string } | null,
    groupByKnowledgeBase?: boolean,
  ) =>
    [
      ...lacQueryKeys.all,
      'platformChatAnalytics',
      tenantName,
      range ?? null,
      groupByKnowledgeBase ?? false,
    ] as const,

  topChatbots: (
    tenantName: string | null,
    criteria: string,
    knowledgeBaseId?: string | null,
    range?: { fromDate: string; toDate: string } | null,
    limit?: number | null,
  ) =>
    [
      ...lacQueryKeys.all,
      'topChatbots',
      tenantName,
      criteria,
      knowledgeBaseId ?? null,
      range ?? null,
      limit ?? null,
    ] as const,

  topPlatformChats: (
    tenantName: string,
    criteria: string,
    knowledgeBaseId?: string | null,
    range?: { fromDate: string; toDate: string } | null,
  ) =>
    [
      ...lacQueryKeys.all,
      'topPlatformChats',
      tenantName,
      criteria,
      knowledgeBaseId ?? null,
      range ?? null,
    ] as const,

  costLimits: () => [...lacQueryKeys.all, 'costLimits'] as const,

  costLimit: (tenantName: string) =>
    [...lacQueryKeys.all, 'costLimit', tenantName] as const,

  tenantCosts: (tenantName: string) =>
    [...lacQueryKeys.all, 'tenantCosts', tenantName] as const,

  tenantDailyCosts: (tenantName: string, fromDay: string, toDay: string) =>
    [
      ...lacQueryKeys.tenantCosts(tenantName),
      'dailyCosts',
      fromDay,
      toDay,
    ] as const,

  tenantMonthlyCosts: (
    tenantName: string,
    fromMonth: string,
    toMonth: string,
  ) =>
    [
      ...lacQueryKeys.tenantCosts(tenantName),
      'monthlyCosts',
      fromMonth,
      toMonth,
    ] as const,

  crawlJobTimeSeriesRoot: () =>
    [...lacQueryKeys.all, 'crawlJobTimeSeries'] as const,

  crawlJobTimeSeries: (
    tenantName: string | null,
    groupBy: string,
    fromDate: string,
    toDate: string,
  ) =>
    [
      ...lacQueryKeys.crawlJobTimeSeriesRoot(),
      tenantName,
      groupBy,
      fromDate,
      toDate,
    ] as const,

  crawlJobAnalyticsRoot: () =>
    [...lacQueryKeys.all, 'crawlJobAnalytics'] as const,

  crawlJobAnalytics: (tenantName: string, fromDate: string, toDate: string) =>
    [
      ...lacQueryKeys.crawlJobAnalyticsRoot(),
      tenantName,
      fromDate,
      toDate,
    ] as const,

  knowledgeBaseDocumentAnalytics: (
    tenantName: string | null,
    range?: { fromDate: string; toDate: string } | null,
  ) =>
    [
      ...lacQueryKeys.all,
      'knowledgeBaseDocumentAnalytics',
      tenantName,
      range ?? null,
    ] as const,
};
